import React from 'react';
import Page from '../../Components/Page';

const Videos = () => {
  return (
    <Page className="text-center">
      <h2 className="text-2xl">Videos</h2>
      <h3>Coming Soon</h3>
    </Page>
  );
};

export default Videos;
